export const scheduleRulesetText = {
  titleText: 'Schedule Ruleset',
  searchPlaceholder: 'Cari account ID disini...',
  buttonAddText: 'Buat Ruleset Baru',
  selectBrandPlaceholder: 'Pilih Brand',
};

export const deleteActionText = {
  titleText: 'Yakin ingin hapus Ruleset?',
  contentHtmlDescription: '<div>Kamu akan menghapus ruleset :</br>{rulesets}</br>{type}</br></br>Apakah kamu yakin ingin menghapusnya?</div>',
  submitButtonText: 'Ya, Hapus',
  cancelButtonText: 'Tutup',
  loadingTitle: 'Menghapus Ruleset',
  loadingDescription: 'Sedang menghapus ruleset, mohon tunggu...',
  successDescription: 'Ruleset berhasil dihapuskan',
  errorTitle: 'Gagal Menghapus Ruleset',
  errorDescription: 'Terjadi kesalahan saat menghapus ruleset',
};

export const confirmEditText = {
  titleText: 'Simpan Perubahan?',
  contentDescription: 'Pastikan perubahan yang kamu lakukan pada ruleset ini sudah final.',
  submitButtonText: 'Ya, Simpan',
  cancelButtonText: 'Batal',
  successDescription: 'Perubahan ruleset berhasil disimpan',
  errorDescription: 'Terjadi kesalahan saat menyimpan perubahan ruleset',
};

export const confirmCreateText = {
  titleText: 'Simpan Ruleset',
  contentDescription: 'Pastikan ruleset sudah benar sebelum menyimpannya.',
  submitButtonText: 'Ya, Simpan',
  cancelButtonText: 'Batal',
  successDescription: 'Ruleset baru berhasil ditambahkan',
  errorDescription: 'Terjadi kesalahan saat menyimpan ruleset',
};

export const formUpsertText = {
  cancelConfirmationTitle: 'Yakin ingin membatalkan?',
  cancelHtmlConfirmationDesc: '<div>Perubahan yang telah kamu buat tidak akan tersimpan.<br/>Apakah kamu yakin ingin membatalkan?</div>',
  cancelSubmitButton: 'Ya, Batalkan',
  cancelCancelButton: 'Tutup',
  brandLabel: 'Brand',
  brandPlaceholder: 'Pilih brand',
  typeLabel: 'Tipe Livestream',
  typePlaceholder: 'Pilih tipe livestream',
  normalLiveHoursLabel: 'Waktu Live Per Hari',
  liveHoursPlaceholder: 'Masukkan jam live',
  hourSuffix: 'Jam/hari',
  paydayLiveHoursLabel: 'Waktu Live Event Khusus',
  hourPlaceholder: '00:00',
  accountIdLabel: 'Account ID',
  accountIdPlaceholder: 'Pilih account ID',
  studioLabel: 'Studio',
  studioPlaceholder: 'Pilih studio',
  hostLabel: 'Host',
  hostPlaceholder: 'Pilih host',
  specialEventToolTip: 'Event khusus seperti Payday, Doubledate, Peakday ataupun event lainnya',
  useAgencyLabel: 'Pakai Agency',
  agencyNormalLabel: 'Waktu Live Agency per hari',
  agencyPaydayLabel: 'Waktu Live Event Khusus',
  cancelButtonText: 'Batal',
  submitButtonText: 'Simpan',
  submitButtonTextEdit: 'Simpan Perubahan',
};
